import React, { useState, useEffect } from 'react';
import Navigation from "../navigation";
import Menus from "../../../data/menus";
import AppIcon from "../../../assets/transcript-app-icon.png";
import { NotificationCenter } from "../../ui/ToastNotification";

export default function Header() {
  const [notifications, setNotifications] = useState(() => {
    try {
      const saved = localStorage.getItem('appNotifications');
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem('appNotifications', JSON.stringify(notifications));
  }, [notifications]);

  const handleClearAll = () => {
    setNotifications([]);
  };

  const handleDismiss = (id) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  };

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200 shadow-md">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center gap-4">
        <a href="/" className="flex items-center gap-2 shrink-0">
          <img src={AppIcon} alt="Transcript App" className="h-10 md:h-12 w-auto" />
          <span className="sr-only">Transcript App</span>
        </a>
        <Navigation menu={Menus.MainMenu} orientation="horizontal" />
        <div className="ml-auto flex items-center gap-2">
          <NotificationCenter 
            notifications={notifications} 
            onClearAll={handleClearAll}
            onDismiss={handleDismiss}
          />
        </div>
      </div>
    </header>
  );
}
